// src/services/cityService.ts

class CityService {
  // Inicijalizuj kao prazan niz
  private cities: string[] = [];

  /**
   * Dohvata gradove iz JSON fajla
   */
  async getCities(): Promise<string[]> {
    // Ako već imamo gradove, vrati ih
    if (this.cities.length > 0) {
      return this.cities;
    }

    try {
      // Učitavanje JSON fajla iz public direktorijuma
      const response = await fetch('/cities.json');
      const data = await response.json();
      this.cities = data.cities;
      return this.cities;
    } catch (error) {
      console.error('Failed to load cities:', error);

      // Fallback na hardkodovane gradove ako JSON nije dostupan
      this.cities = this.getFallbackCities();
      return this.cities;
    }
  }

  /**
   * Vraća hardkodovane gradove kao rezervnu opciju
   */
  private getFallbackCities(): string[] {
    return [
      'Beograd',
      'Novi Sad',
      'Niš',
      'Kragujevac',
      'Subotica',
      // Samo osnovni gradovi kao backup
    ];
  }
}

// Kreiramo singleton instancu
const cityService = new CityService();
export default cityService;
